import { createAtom } from '../../../1stlog-ui/src/utils/recoil'

const prefix = 'components/OrderDetail'

export const showOldState = createAtom<boolean>({
  prefix,
  key: 'showOld',
  default: false,
})

export const showNewState = createAtom<boolean>({
  prefix,
  key: 'showNew',
  default: true,
})
